import { notFound } from "@tanstack/react-router";
import { isAssetSupported } from "../../../shared/utils/asset-config";

/**
 * Loader for routes with asset parameters
 * Validates that the asset is supported, shows 404 if not
 * The typed router should ensure asset is always provided
 */
export async function assetRouteLoader({ params }: { params: { asset: string } }) {
  const { asset } = params;

  // Check if asset is supported
  if (!isAssetSupported(asset)) {
    // Show 404 for unsupported assets
    throw notFound();
  }

  return null;
}
